<div class="map-wrapper">
    @if (!sidebarIsMinimized) {
        <ui-minimize-sidebar-button (click)="sidebarMinimized.emit()"/>
    }
    @if (isFullscreenAvailable && !isFullscreen) {
        <ui-maximize-map-with-sidebar-button
            (click)="maximizeMapWithSidebar()"
        />
    }
    @if (isFullscreenAvailable && isFullscreen) {
        <ui-minimize-map-with-sidebar-button
            (click)="minimizeMapWithSidebar()"
        />
    }
    <mgl-map
        #map
        class="map"
        [mapStyle]="mapStyles"
        [zoom]="mapZoom()"
        [minZoom]="10"
        [maxZoom]="20"
        [center]="mapPoints.augsburg"
        [boxZoom]="true"
        [scrollZoom]="false"
        [maxBounds]="mapBounds"
        (mapLoad)="setupMap($event)"
        (zoomEvt)="updateMapZoom($event)"
        (mapError)="handleMapError($event)"
    >
        <mgl-control mglNavigation [showCompass]="false" [position]="'bottom-left'"/>

        @if ((visibleMapMarkerIds$ | async); as visibleMapMarkerIds) {
            <!--
            Area item icons should disappear when zoomed out far enough
            Point item icons should disappear if their points are in a cluster
            -->
            <!-- See: https://youtrack.jetbrains.com/issue/WEB-67475/Angular-for-control-flow-and-type-inference-with-Zod-readonly-array -->
            @for (mapItem of mapItems.data; track mapItem.uniqueId) {
                <ui-map-marker-with-popup
                    [hidden]="!(mapItem.isArea && mapZoom() >= 12) && !visibleMapMarkerIds[mapItem.uniqueId]"
                    [mapItem]="mapItem"
                    [popupContentComponentType]="popupContentComponentType"
                    (markerPopupOpened)="handleMarkerPopupOpened($event)"
                    (markerPopupClosed)="handlePopupClosed($event)"
                />
            }
        }
    </mgl-map>

    @if (isWebglUnavailable()) {
        <div class="map-unavailable">
            <i class="map-unavailable__icon pi pi-exclamation-triangle"></i>
            <p>
                Die Karte kann in diesem Browser nicht angezeigt werden, da dieser WebGL nicht
                unterst&uuml;tzt oder erlaubt. Bitte aktivieren Sie die Hardwarebeschleunigung
                oder verwenden Sie einen anderen Browser.
            </p>
        </div>
    }

    <ui-show-map-items-button (click)="onlyShowMapItems.emit()"/>

    @if (isMapDataLoading && ((isMobile && isShowingMap) || sidebarIsMinimized)) {
        <div
            class="reloading-indicator"
        >
            <i class="reloading-indicator__icon pi pi-spin pi-spinner"></i>
        </div>
    }
</div>
